import React from 'react';
import ShowCart from '../ShowCart';
import { savedCartContext } from '../../../Context/savedCartContext';

function ShowLatestCart() {
  return (
    <div className="mb-4 pb-4">
      <savedCartContext.Consumer>
        {({savedCartDetails, refreshSavedCartDetails}) =>
          <ShowCart
            savedCartDetails={savedCartDetails}
            refreshSavedCartDetails={refreshSavedCartDetails}
          />
        }
      </savedCartContext.Consumer>
    </div>
  );
}

export default ShowLatestCart;
